<!--分类-->
<template>
  <div class="type-box">
    <HeadSearch></HeadSearch>
    <div class="type-select">
      <div class="select-left">
        <ul>
          <li
            :class="selectCateId == cate.id ? 'select-left-active': ''"
            v-for="(cate, index) in cateTree"
            @click="cateChange(index)"
          >{{cate.name}}</li>
          <!--<li>母婴健康</li>
					<li>生活创意</li>
					<li>运动</li>
					<li>洗护</li>
					<li>海外</li>
					<li>年货</li>
					<li>彩妆</li>
          <li>萌宠</li>-->
        </ul>
      </div>
      <div class="select-right">
        <ul>
          <li v-for="(goods, index) in subCateList" @click="goGoodsList(goods.id)">
            <img :src="goods.pic_url" alt />
            <p>{{goods.name}}</p>
          </li>
          <!--<li>
						<img src="../../assets/newImg/pic-cates-pic1.png" alt="">
						<p>美味成品</p>
					</li>
					<li>
						<img src="../../assets/newImg/pic-cates-pic1.png" alt="">
						<p>美味成品</p>
					</li>
					<li>
						<img src="../../assets/newImg/pic-cates-pic1.png" alt="">
						<p>美味成品</p>
					</li>
					<li>
						<img src="../../assets/newImg/pic-cates-pic1.png" alt="">
						<p>美味成品</p>
					</li>
					<li>
						<img src="../../assets/newImg/pic-cates-pic1.png" alt="">
						<p>美味成品</p>
          </li>-->
        </ul>
        <!-- <ul>
					二级类型容器
        </ul>-->
      </div>
    </div>
    <!-- 底部导航 -->
    <TabBar :show-tab-bar="true"></TabBar>
  </div>
</template>
<style scoped>
@import "../../assets/style/index.css";

.type-box {
  height: 100%;
}
</style>

<script>
import TabBar from "@/components/TabBar.vue";
HeadSearch;
import HeadSearch from "@/components/HeadSearch.vue";
import Vue from "vue";
import { TreeSelect } from "vant";
Vue.use(TreeSelect);
export default {
  name: "GoodsCates",
  components: {
    TabBar,
    HeadSearch
  },
  data: function() {
    return {
      cateTree: [],
      selectCateId: 0,
      subCateList: []
    };
  },
  filter: {},
  mounted() {
    document.title = "商品分类";
    this.getCateTree();
  },
  destroyed() {},
  methods: {
    getCateTree() {
      let that = this;
      this.$api.get("/api/goods/cateTree", {}, res => {
        // console.log(res)
        that.cateTree = res.data;
        that.selectCateId = that.cateTree[0].id;
        that.subCateList = that.cateTree[0].children
          ? that.cateTree[0].children
          : [];
      });
    },

    // 更改分类
    cateChange(index) {
      // console.log(index)
      let that = this;
      that.selectCateId = that.cateTree[index].id;
      that.subCateList = that.cateTree[index].children
        ? that.cateTree[index].children
        : [];
    },

    goGoodsList(id) {
      rbLink({
        name: "GoodsList",
        query: {
          cate_id: id
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// GoodsCates.vue?bda3072a